import { useContext } from 'react';
import Image from 'next/image';
import { NewPlanStages } from 'components/newPlan/constants';
import * as Styles from './styles';
import { getImageBasePath } from 'utils/generics';
import { MPosContext } from 'utils/context';
import sendSegmentEvent from 'utils/segment';
import {
    SegmentEventActionTypes,
    SegmentEventButtonNames,
    SegmentEventActionNames,
    SegmentEventNameTypes,
} from 'utils/segment/constants';
import { useResponsiveDevice } from 'hooks/useResponsiveDevice';

function PlansHeader() {
    const { planDetails, setActiveStage, partnerId, userDetails } =
        useContext(MPosContext);
    const { isMobile } = useResponsiveDevice();

    const { device } = planDetails;

    const _getHeaderImage = () => {
        if (partnerId === 'ather') {
            return getImageBasePath('/icons/bike.svg');
        }

        return getImageBasePath('/icons/phone.svg');
    };

    const onEditClick = () => {
        setActiveStage(NewPlanStages.MODEL);
        sendSegmentEvent(
            SegmentEventNameTypes.ACTION,
            {
                action_type: SegmentEventActionTypes.TAP_BTN,
                action_name: SegmentEventActionNames.CLICK_EDIT_MODEL,
                button_name: SegmentEventButtonNames.CLICK_EDIT_MODEL,
            },
            { userDetails, isMobile }
        );
    };

    return (
        <>
            <Styles.HeaderWrapper>
                <Styles.PhoneIconFlex>
                    <Image
                        width={partnerId === 'ather' ? '24px' : '11px'}
                        height={partnerId === 'ather' ? '24px' : '16px'}
                        alt={''}
                        src={_getHeaderImage()}
                    />
                </Styles.PhoneIconFlex>
                <Styles.ModelNameFlex>
                    <Styles.ModelName>{device.name}</Styles.ModelName>
                </Styles.ModelNameFlex>
                <Styles.EditFlex>
                    <Styles.Edit onClick={onEditClick}>Edit</Styles.Edit>
                </Styles.EditFlex>
            </Styles.HeaderWrapper>
            <Styles.Hr />
        </>
    );
}

export default PlansHeader;
